import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';
import { createStore, compose } from 'redux';
import { reactReduxFirebase } from 'react-redux-firebase';
import reducers from './reducers/index';

const firebaseConfig = {
    apiKey: "AIzaSyBYCukeWo0dTQj0IV96tZAsn5GgRKRE07g",
    authDomain: "abbaquiz.firebaseapp.com",
    databaseURL: "https://abbaquiz.firebaseio.com",
    projectId: "abbaquiz",
    storageBucket: "abbaquiz.appspot.com",
    messagingSenderId: "227245425478"
};

// react-redux-firebase config
// TODO: What is this??
const rrfConfig = {
    userProfile: 'users'
};

// Initialize firebase instance
firebase.initializeApp(firebaseConfig);

// Add reactReduxFirebase enhancer when making store creator
const createStoreWithFirebase = compose(
    reactReduxFirebase(firebase, rrfConfig),
)(createStore);


// Create store with reducers and initial state
const initialState = {};
export const store = createStoreWithFirebase(reducers, initialState);